import { useMatch } from 'react-router-dom';

const usePageType = () => {
  const bookingMatch = useMatch('/booking');
  const bookingReskinMatch = useMatch('/booking-reskin');
  const editBookingMatch = useMatch('/booking/:id');
  const payBookingMatch = useMatch('/booking/:id/pay');
  const addonsBookingMatch = useMatch('/booking/:id/addons');
  const giftcardMatch = useMatch('/giftcard');
  const membershipMatch = useMatch('/goboat-plus/:planId');

  return bookingMatch
    ? 'booking'
    : bookingReskinMatch
    ? 'booking'
    : editBookingMatch
    ? 'edit-booking'
    : payBookingMatch
    ? 'edit-booking'
    : addonsBookingMatch
    ? 'edit-booking'
    : giftcardMatch
    ? 'giftcard'
    : membershipMatch
    ? 'membership'
    : 'unknown';
};

export default usePageType;
